import React from "react"
import { AlertTriangle, Calendar, CalendarDays, Banknote } from "lucide-react"
import { formatINR } from "../constants"

const CARDS = [
  {
    key: "overdue",
    label: "Overdue",
    icon: AlertTriangle,
    amountKey: "overdue_amount",
    countKey: "overdue_count",
    iconColor: "text-red-500",
    bgColor: "bg-red-50",
  },
  {
    key: "due_week",
    label: "Due this week",
    icon: Calendar,
    amountKey: "due_this_week",
    iconColor: "text-amber-500",
    bgColor: "bg-amber-50",
  },
  {
    key: "due_month",
    label: "Due this month",
    icon: CalendarDays,
    amountKey: "due_this_month",
    iconColor: "text-blue-500",
    bgColor: "bg-blue-50",
  },
  {
    key: "collected",
    label: "Collected this month",
    icon: Banknote,
    amountKey: "collected_this_month",
    iconColor: "text-emerald-500",
    bgColor: "bg-emerald-50",
  },
]

export default function DuesSummaryCards({ totals }) {
  if (!totals) return null

  return (
    <div className="grid grid-cols-2 gap-3 lg:grid-cols-4">
      {CARDS.map(({ key, label, icon: Icon, amountKey, countKey, iconColor, bgColor }) => (
        <div
          key={key}
          className="rounded-lg border border-slate-200 bg-white p-4"
        >
          <div className="flex items-center gap-2">
            <div className={`rounded-md p-1.5 ${bgColor}`}>
              <Icon className={`h-4 w-4 ${iconColor}`} />
            </div>
            <span className="text-[12px] font-medium text-slate-500">{label}</span>
          </div>
          <div className="mt-2 flex items-baseline gap-2">
            <span className="text-[22px] font-semibold text-slate-900">
              {formatINR(totals[amountKey])}
            </span>
            {countKey && totals[countKey] != null && (
              <span className="text-[12px] text-slate-400">
                {totals[countKey]} due
              </span>
            )}
          </div>
        </div>
      ))}
    </div>
  )
}
